<template>
    <div id="settings">
        <section>
          <transition name="fade">
            <div v-if="showSignOutConfirmation" class="alertBox">
              <div>
                <h5>Sign Out</h5>
                <p>Sure you want to sign out?</p>
                <button class="destructive" v-on:click="showSignOutConfirmation = false">No</button>
                <button v-on:click="showSignOutConfirmation = false; signOut()">Yes</button>
              </div>
            </div>
            <div v-if="showUpdateNameInvalid" class="alertBox">
              <div>
                <h5>Change Name</h5>
                <p>Please enter at least a given name.</p>
                <button v-on:click="showUpdateNameInvalid = false">OK</button>
              </div>
            </div>
            <div v-if="showUpdateNameSuccess" class="alertBox">
              <div>
                <h5>Change Name</h5>
                <p>Your name was successfully changed to {{ appUser.givenName }} {{ appUser.familyName }}.</p>
                <button v-on:click="showUpdateNameSuccess = false">OK</button>
              </div>
            </div>
            <div v-if="showUpdatePhoneNumberConfirmation" class="alertBox">
              <div>
                <h5>Change Phone Number</h5>
                <p>Are you sure you want to change your phone number? You'll need to login using the new phone number and then be reinvited to any upcoming events.</p>
                <button class="destructive" v-on:click="showUpdatePhoneNumberConfirmation = false">No</button>
                <button v-on:click="showUpdatePhoneNumberConfirmation = false; updateAppUserPhoneNumber()">Yes</button>
              </div>
            </div>
            <div v-if="showUpdatePhoneNumberInvalid" class="alertBox">
              <div>
                <h5>Change PhoneNumber</h5>
                <p>Please enter a 9-digit phone number and applicable country code.</p>
                <button v-on:click="showUpdatePhoneNumberInvalid = false">OK</button>
              </div>
            </div>
            <div v-if="showUpdatePhoneNumberSuccess" class="alertBox">
              <div>
                <h5>Change Phone Number</h5>
                <p>Your phone number was successfully changed to {{ this.phoneNumber }}.</p>
                <button v-on:click="showUpdatePhoneNumberSuccess = false">OK</button>
              </div>
            </div>
          </transition>
          
          <h5>Account ({{ appUser.givenName }} {{ appUser.familyName }})</h5>

          <form v-on:submit.prevent>
            <button @click="showSignOutConfirmation = true">Sign Out</button>
          </form>

          <form v-on:submit.prevent>
            <h5>Change name</h5>
            <label for="givenName">Given Name</label>
            <input v-model.trim="givenName" type="text" :placeholder="appUser.givenName" id="givenName" />

            <label for="familyName">Family Name</label>
            <input v-model.trim="familyName" type="text" :placeholder="appUser.familyName" id="familyName" />

            <button @click="updateAppUserName()">Update Name</button>
          </form>

          <form v-on:submit.prevent>
            <h5>Change phone number</h5>
            <label for="familyName">Phone Number</label>
            <input v-model.trim="phoneNumber" type="text" :placeholder="appUser.phoneNumber" id="familyName" />

            <button @click="showUpdatePhoneNumberConfirmation = true">Update Phone Number</button>
          </form>
        </section>
    </div>
</template>

<script>
  import { mapState } from 'vuex'
  const fb = require("../firebaseConfig.js")

  export default {
      data() {
          return {
              givenName: '',
              familyName: '',
              phoneNumber: '',
              showSignOutConfirmation: false,
              showUpdateNameInvalid: false,
              showUpdateNameSuccess: false,
              showUpdatePhoneNumberConfirmation: false,
              showUpdatePhoneNumberInvalid: false,
              showUpdatePhoneNumberSuccess: false
          }
      },
      computed: {
          ...mapState(['appUser'])
      },
      methods: {
      signOut() {
        this.$store.dispatch('updateAppUserSignedIn', { isSignedIn: false })
        fb.auth.signOut().then(() => {
          this.$store.dispatch('clearData')
          this.$router.push('/getstarted')
        }).catch(err => {
          console.log(err)
        })
      },
      updateAppUserName() {
        if (this.givenName !== '') {
          this.$store.dispatch('updateAppUserName', {
            givenName: this.givenName,
            familyName: this.familyName !== '' ? this.familyName : this.appUser.familyName,
          })

          this.givenName = ''
          this.familyName = ''

          this.showUpdateNameSuccess = true

          setTimeout(() => { this.showUpdateNameSuccess = false }, 2000)
        }
        else {
          this.showUpdateNameInvalid = true
        }
      },
      updateAppUserPhoneNumber() {
        if (this.phoneNumber !== '') {
          this.$store.dispatch('updateAppUserPhoneNumber', {
            phoneNumber: this.phoneNumber
          })

          this.phoneNumber = ''

          this.showUpdatePhoneNumberSuccess = true

          setTimeout(() => { this.showUpdatePhoneNumberSuccess = false }, 2000)
        }
        else {
          this.showUpdatePhoneNumberInvalid = true
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Settings.vue